var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFintarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 81,
    viewBox: "0 0 335 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.527 26.7177V31.7262H265.214V52.8593H270.413V31.7209H278.213V26.7124L257.527 26.7177ZM235.734 52.854H253.969V47.8456H240.784V42.2519H253.041V37.3225H240.784V31.7209H253.969V26.7124H235.734V52.854ZM162.504 42.6736L165.996 33.1839L169.486 42.6736H162.504ZM163.508 26.7309L153.146 52.8672H158.652L160.695 47.2314H171.156L173.345 52.8672H178.73L168.481 26.7309H163.508ZM125.161 44.2289L112.689 26.7177H107.891V52.854H112.83V35.3428L125.31 52.854H130.03V26.7177H125.161V44.2289ZM94.7475 52.854H99.9099V26.7177H94.7501L94.7475 52.854ZM70.9124 52.854H76.0013V42.2519H88.2558V37.3225H76.004V31.7209H89.1892V26.7124H70.915L70.9124 52.854ZM154.355 26.7177H133.711V31.7262H141.361V52.8593H146.56V31.7209H154.358L154.355 26.7177Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.844 37.5835V42.2519H224.822V47.2604C223.592 47.888 222.229 48.2073 220.85 48.1909C215.389 48.1909 212.085 44.764 212.085 39.8267C212.085 34.8183 215.389 31.3123 220.887 31.3123C225.045 31.3123 227.905 33.1048 229.015 34.0775V28.5102C228.123 27.7642 225.226 26.3829 220.887 26.3829C212.604 26.3829 206.886 32.1321 206.886 39.8267C206.886 47.4449 212.604 53.1941 220.52 53.1941C223.697 53.1739 226.793 52.1839 229.397 50.3551V37.5835H218.844Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.092 39.0781H187.56V31.7209H193.092C196.139 31.7209 197.848 33.039 197.848 35.3798C197.848 37.8076 196.139 39.0781 193.092 39.0781ZM202.825 35.3877C202.825 30.1973 198.923 26.7256 192.759 26.7256H182.398V52.862H187.56V43.968H191.868L197.403 52.8541H203.231L197.18 43.3327C200.743 42.0279 202.825 39.0781 202.825 35.3798V35.3877Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M290.273 49.7224C290.273 51.4042 289.028 52.854 286.173 52.854H281.661V42.0093H286.021C288.8 42.0093 289.954 43.4302 289.954 45.0645C289.954 45.5592 289.801 46.0417 289.515 46.4444C289.229 46.8471 288.825 47.1499 288.36 47.3104C289.576 47.6821 290.273 48.4861 290.273 49.7224ZM283.457 43.6279V46.5776H286.026C287.62 46.5776 288.168 45.8579 288.168 45.0645C288.168 44.2711 287.62 43.6279 286.026 43.6279H283.457ZM286.178 51.2355C287.833 51.2355 288.485 50.471 288.485 49.7224C288.485 48.9737 287.961 48.1408 286.191 48.1408H283.457V51.2407L286.178 51.2355Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M302.935 49.0002C302.41 51.4438 300.397 53.0017 297.874 53.0017C294.466 53.0017 292.329 50.5133 292.329 47.4265C292.329 44.3397 294.458 41.8513 297.874 41.8513C300.397 41.8513 302.418 43.4092 302.935 45.8528H301.157C300.716 44.2184 299.348 43.4803 297.874 43.4803C295.415 43.4803 294.123 45.3256 294.123 47.4344C294.123 49.5432 295.415 51.3884 297.874 51.3884C299.348 51.3884 300.716 50.6398 301.157 49.016L302.935 49.0002Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M306.631 49.6486C306.631 50.1969 307.011 51.3883 309.381 51.3883C311.447 51.3883 312.1 50.5474 312.1 49.8067C312.1 49.066 311.523 48.602 310.582 48.3411C309.641 48.0801 308.029 47.8376 307.027 47.4712C306.025 47.1048 305.066 46.3561 305.066 44.9959C305.066 43.3616 306.377 41.8643 309.457 41.8643C312.376 41.8643 313.726 43.4987 313.726 45.1488H311.964C311.964 44.4318 311.356 43.4829 309.413 43.4829C307.559 43.4829 306.859 44.2315 306.859 45.0276C306.859 45.8237 307.544 46.1874 308.849 46.4484C309.934 46.6295 311.002 46.9047 312.04 47.2708C313.196 47.7295 313.894 48.5704 313.894 49.8067C313.894 51.4885 312.648 53.0148 309.337 53.0148C306.099 53.0148 304.838 51.304 304.838 49.6565L306.631 49.6486Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3003 60C51.359 60 60.3239 51.0457 60.3239 40C60.3239 28.9543 51.359 20 40.3003 20C29.2415 20 20.2766 28.9543 20.2766 40C20.2766 51.0457 29.2415 60 40.3003 60Z",
    fill: "url(#paint0_linear_17_1191)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.36 23.4152C22.7028 29.4636 23.4253 40.3612 30.9756 47.7531C38.5234 55.145 50.0381 56.2366 56.6978 50.1856C57.4523 49.5 58.1121 48.7523 58.6779 47.9545C59.7371 45.5167 60.3242 42.8268 60.3242 40C60.3242 28.9543 51.3593 20 40.3006 20C36.5784 20 33.0935 21.0144 30.1077 22.7815C29.8523 22.9832 29.6029 23.1944 29.36 23.4152Z",
    fill: "url(#paint1_radial_17_1191)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7195 23.414C27.5686 28.207 31.238 35.6557 38.9164 40.0465C46.5948 44.4399 55.3708 44.1139 58.5243 39.3182C59.4149 37.9639 59.7613 36.398 59.627 34.7492C57.318 26.2506 49.5401 20 40.3005 20C37.5102 20 34.8532 20.5701 32.4399 21.5999C31.7602 22.1088 31.1798 22.7137 30.7195 23.414Z",
    fill: "url(#paint2_radial_17_1191)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_1191",
    x1: 51.1191,
    y1: 84.859,
    x2: 37.5175,
    y2: -5.57742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303516,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733277,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_17_1191",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.246 41.7105) rotate(106.278) scale(36.1876 30.4648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279744,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450971,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_17_1191",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.036 12.6694) rotate(53.1036) scale(50.7038 56.5649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136507,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397079,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725487,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintarget);
export default __webpack_public_path__ + "static/media/fintarget.4a53bc574a09ecdf92c0b8389412dbd4.svg";
export { ForwardRef as ReactComponent };